


















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
import dayjs from "dayjs";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class storeApplet extends Vue {
  timeValue = [];
  /**登陆信息 */
  public userInfo =
    localStorage.getItem("dayChecked") == "true"
      ? JSON.parse(localStorage.getItem("userInfo"))
      : JSON.parse(sessionStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    member: "",
    cashier: "",
    orderType: 2,
    startTime: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    endTime: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    paymentMethod: null,
    sortType: 1,
    sortValue: 2,
    skip: 0,
    count: 10,
  };
  appletStatusList = [
    { label: "会员卡支付", value: 1 },
    { label: "现金支付", value: 2 },
    { label: "微信支付", value: 3 },
    { label: "支付宝支付", value: 4 },
    { label: "现金+会员卡+微信", value: 5 },
    { label: "现金+会员卡+支付宝", value: 6 },
    { label: "现金+微信", value: 7 },
    { label: "现金+支付宝", value: 8 },
    { label: "会员卡+微信", value: 9 },
    { label: "会员卡+支付宝", value: 10 },
    { label: "现金+会员卡", value: 11 },
    { label: "混合支付", value: 12 },
  ];
  /**列表选项 */
  selectTable = [];
  exloading = false;
  // 合计
  totalnum = "-0";
  totalthprice = "-0.00";
  async mounted() {
    this.timeValue = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    await this.getlist();
    await this.getTotal();
    // handleEnter(this.handleSearch)
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetTbSaleReportList(this.searchValue);
    this.listData = result.items.map((v) => {
      return {
        ...v,
        orderDate: v.orderDate ? dayjs(v.orderDate).format("YYYY-MM-DD") : "/",
        totalRefunded: v.totalRefunded ? "-" + fmoney(v.totalRefunded) : "-0.00",
        num: v.num ? "-" + v.num : "-0",
        memberPhone: v.memberPhone ? v.memberPhone : "/",
      };
    });
    this.total = result.totalCount;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  /**获取列表信息 */
  public async getTotal() {
    this.loading = true;
    let result = await Public.GetTbSaleReportTotal(this.searchValue);
    this.totalnum = result.num ? "-" + result.num : "-0";
    this.totalthprice = result.totalRefunded
      ? "-" + fmoney(result.totalRefunded)
      : "-0.00";
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = "合计";
    sums[2] = this.totalnum;
    sums[3] = this.totalthprice;
    return sums;
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    await this.getTotal();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      member: "",
      cashier: "",
      orderType: 2,
      startTime: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
      endTime: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
      paymentMethod: null,
      sortType: 1,
      sortValue: 2,
      skip: 0,
      count: 10,
    };
    await this.getlist();
    await this.getTotal();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  //   /**查看详情 */
  //   viewRow(id) {
  //     this.$router.push(`./storeAppletDetail?id=${id}&name=detail`);
  //   }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.startTime = val[0] + " 00:00:00";
      this.searchValue.endTime = val[1] + " 23:59:59";
    } else {
      this.searchValue.startTime = "";
      this.searchValue.endTime = "";
    }
  }

  export_table(item) {
    try {
      this.exloading = true;
      Public.TbSaleReportExport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        // let blob = new Blob([res]);
        // var objectUrl = URL.createObjectURL(blob);
        // var fileName = objectUrl.substring(objectUrl.lastIndexOf("/") + 1);
        var fileName = "退货订单报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/returnOrder/index.vue